<template>
  <div class="content">
    <div class="inner_content">
      <div class="table">
        <el-card
          :body-style="{ padding: '0px' }"
          v-for="(item, index) in table"
          :key="index"
        >
          <img :src="item.image.url" class="image" />
          <div style="padding: 14px;">
            <span>金额： {{ item.money }}元</span>
            <div class="bottom clearfix">
              <!-- <time class="time">dfdfd</time> -->
              <el-button type="text" class="button" @click="delWX(item.id)"
                >删除</el-button
              >
            </div>
          </div>
        </el-card>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :total="table.length"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { weixinList, weixinDel } from "@/api/pay";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      alipay_userid: "",
      table: [],
      activeName: "0",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      zhifubaoList: [],
      amend: ""
    };
  },
  mounted() {
    this.getWXlist();
  },
  methods: {
    go(path) {
      console.log("path", path);
      this.$router.push(path);
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    // weixin
    getWXlist() {
      // this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id
        // page: this.page,
      };
      weixinList(data).then(res => {
        console.log("weixin列表", res);
        if (res.code == 200) {
          this.table = res.data;
        }
      });
    },
    // 删除微信配置
    delWX(id) {
      // this.page++;
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            token: this.token,
            app_id: this.app_id,
            id: id
          };
          weixinDel(data).then(res => {
            console.log("删除", res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.reload();
            } else {
              this.$message({
                type: "info",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 24px 24px 0;
    height: 100%;
    .el-card {
      width: 250px;
      height: 329px;
      margin: 0 15px 15px 0px;
      overflow-y: auto;
    }
    .zhifubao-top {
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.table {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0px;
  height: 720px;
  overflow-y: scroll;
}
// 卡片样式
.explain {
  line-height: 30px;
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
